import { computedFrom } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { watch } from 'aurelia-watch-decorator';
import { WidgetController } from 'controls/as-widget-container';
import { BusinessContact } from 'model/forms/travel-request';
import { WidgetBase } from 'support/base_classes/widget-base';
import { PHONE_REGEX } from 'support/settings';

export class BusinessContactWidget extends WidgetBase<BusinessContact, WidgetController> {
  bind() {
    this.bindValidation();
  }

  private bindValidation() {
    ValidationRules
      .ensureObject<BusinessContact>().required()
      .ensure(model => model.name).displayName(`Contact #${this.contactNumber} name`).required().when(model => model.phone != null || model.mail != null)
      .ensure(model => model.phone).displayName(`Contact #${this.contactNumber} phone`).required().when(model => model.name != null || model.mail != null).matches(PHONE_REGEX).withMessage('Phone number in international format is required.')
      .ensure(model => model.mail).displayName(`Contact #${this.contactNumber} e-mail`).required().when(model => model.name != null || model.phone != null).email().withMessage('E-mail address in valid format is required.')
      .on(this.model);
  }

  @computedFrom('controller.index')
  get contactNumber() {
    return this.controller.index + 1;
  }

  @watch((x: BusinessContactWidget) => x.contactNumber)
  private contactNumberChanged() {
    this.bindValidation();
  }
}
